var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"t-tr",style:({
			background: _vm.zebraStripe && (_vm.tableIndex % 2 === 0) ? _vm.zebraColor : '#ffffff'
		})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }